import React, { Component } from 'react';
import propTypes from 'prop-types';
;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import dayjs from 'dayjs-ext';
import { get, find } from 'lodash';
import { connect } from 'react-redux';
import { Navigate, Link } from 'react-router-dom';
import {
  UiToastAdapter,
  reduceServerErrors,
  clearPhoneNumber,
  setBreadcrumbs,
  ConfirmDeletionModal,
  GuidelinesCard,
} from 'src/ui';
import { Button, Columns, Column, MuiTitle, MuiDropdown, MuiDropdownItem } from 'src/ui/mui-ui-kit';;
import { PERSON_TYPE_OWNER, PERSON_TYPE_EMPLOYEE } from 'src/user/const';
import { DEFAULT_DATE_FORMAT } from 'src/ui/const';
import { getUser } from 'src/user';
import { getToken, resetPassword, sendInvite } from 'src/auth';
import {
  getAccount,
  fetchAccount,
  addAccountPersonBadge,
  setAccountPersonBadgeImages,
  addAccountPerson,
  fetchAccountPeople,
  deleteAccountPerson,
  updateAccountPersonStatus,
} from 'src/account';
import { ClientSidePagingManager } from 'src/api';
import {
  startBackgroundCheck,
  BG_CHECK_PACKAGES,
  BANKING_LENDING_BG_CHECK_PACKAGES,
} from 'src/background-check';
import {
  PeopleTable,
  AddPersonModal,
  BackgroundCheckModal,
  InsurancePeopleTable,
} from '../components';
import { PERSON_STATUS } from '../const';
import { PERSON_TYPE_INSURANCE } from '../../user/const';

class PeopleListPage extends Component {
  state = {
    loading: true,
    isAddingOwner: false,
    isAddingEmployee: false,
    addingBadge: false,
    deletingPerson: null,
    people: [],
    runningBackgroundChecks: null,
    bgCheckPackages: [],
    isAdmin: false,
  };

  guidelinesBanking = [
    `In this area we will create a list of all owners and employees, including managers and corporate officers, that work for your organization. Each employee will receive an invite email and be prompted to login.`,
    `Consider that remote "employees" may be contractors and more properly listed as a vendor in the following section.`,
    `If you have a large list of employees please contact support for assistance with uploading them into the system.`,
  ];

  guidelinesPayments = [
    `In this area we will need you to provide personal information for only the owner of the business. You will not need to add any additional personnel at this time.`,
  ];

  guidelinesLending = [
    `Please make sure to add any owner that owns 15% or more of the business.`,
  ];

  guidelinesInsurance = [
    `In this area you can see and edit all members of an account. When basic contact information for a new person is added via the Add Person button you will see their name in the table. Clicking on a user name allows you to add and edit the insurance details of a person.`,
  ];

  constructor(props) {
    super(props);

    this.pagedPeople = new ClientSidePagingManager(
      this.props.fetchAccountPeople, // eslint-disable-line react/destructuring-assignment
      () => this.props.account.people, // eslint-disable-line react/destructuring-assignment
      people => {
        this.setState({ people });
      }
    );
  }

  async componentDidMount() {
    const { token, setBreadcrumbs } = this.props;

    setBreadcrumbs([{ label: 'People', href: '/people' }]);

    if (!token.isEmpty()) {
      const { user } = this.props;
      const isAdmin =
        user.isMerchantAdmin || user.isBankAdmin || user.isSuperAdmin;
      this.setState({ isAdmin });
      let bgCheckPackages = [];
      if (
        user.financialInstitutionForBanking ||
        user.financialInstitutionForLending
      ) {
        bgCheckPackages = bgCheckPackages.concat(
          BANKING_LENDING_BG_CHECK_PACKAGES
        );
      }
      if (user.financialInstitutionForPayments) {
        bgCheckPackages = bgCheckPackages.concat(BG_CHECK_PACKAGES);
      }
      this.setState({ bgCheckPackages });

      if (isAdmin) {
        await this.loadData();
      }
    }
  }

  onToggleAddPerson = type => {
    if (type === PERSON_TYPE_OWNER) {
      const { isAddingOwner } = this.state;
      this.setState({ isAddingOwner: !isAddingOwner, isAddingEmployee: false });
    } else {
      const { isAddingEmployee } = this.state;
      this.setState({
        isAddingEmployee: !isAddingEmployee,
        isAddingOwner: false,
      });
    }
  };

  onToggleAddOwner = () => {
    this.onToggleAddPerson(PERSON_TYPE_OWNER);
  };

  onToggleAddEmployee = () => {
    this.onToggleAddPerson(PERSON_TYPE_EMPLOYEE);
  };

  onCancelAddPerson = form => {
    this.setState({
      isAddingOwner: false,
      isAddingEmployee: false,
    });
    if (form) {
      form.reset();
    }
  };

  // eslint-disable-next-line consistent-return
  onSubmitPerson = async values => {
    const { user, addAccountPerson } = this.props;
    const { isAddingOwner } = this.state;
    await addAccountPerson({
      accountId: user.accountId,
      financialInstitutionId: user.financialInstitutionId,
      isAdmin: false,
      isSigner: false,
      ...values,
      type: isAddingOwner ? 'OWNER' : 'EMPLOYEE',
      primaryNumber: clearPhoneNumber(values.primaryNumber),
      insuranceGroupName: values.insuranceGroupName,
    });

    const { account } = this.props;

    if (account.isError()) {
      return reduceServerErrors(account);
    }
    this.onCancelAddPerson();
    this.pagedPeople.refresh();
    toast(UiToastAdapter('Person added successfully!', 'success'));
  };

  onAddBadge = person => {
    this.setState({ addingBadge: person });
  };

  onCancelBadge = () => {
    this.setState({ addingBadge: false });
  };

  async setBadgeImages(id, number, front, back) {
    const { setAccountPersonBadgeImages, user, account } = this.props;
    const person = find(account.people, { id });
    const badge = find(person.badges, { badgeNumber: number });

    const badgeImages = {
      accountId: user.accountId,
      personId: id,
      badgeId: badge.id,
      imageFront: front,
      imageBack: back,
    };

    await setAccountPersonBadgeImages(badgeImages);

    const { account: finishedAccount } = this.props;

    if (finishedAccount.isError()) {
      return reduceServerErrors(finishedAccount);
    }
    this.setState({ addingBadge: false });
    toast(UiToastAdapter('Badge added successfully!', 'success'));
    return undefined;
  }

  dropdown = () => {
    // Define handlers outside of render to avoid recreating functions
    const handleEmployeeClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.onToggleAddEmployee();
    };
    
    const handleOwnerClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.onToggleAddOwner();
    };
    
    return (
      <MuiDropdown
        isAlign="right"
        renderTrigger={
          <Button isColor="gradient-bright">
            <span>Add Person</span>
            <span className="icon">
              <FontAwesomeIcon icon={['fal', 'angle-down']} />
            </span>
          </Button>
        }
      >
        <MuiDropdownItem
          tag="a"
          onClick={handleEmployeeClick}
        >
          Add Employee
        </MuiDropdownItem>
        <MuiDropdownItem
          tag="a"
          onClick={handleOwnerClick}
        >
          Add Owner
        </MuiDropdownItem>
      </MuiDropdown>
    );
  };

  submitBadge = async values => {
    const { addingBadge: id } = this.state;
    const { addAccountPersonBadge, user } = this.props;

    const { badgeImageFront, badgeImageBack } = values;

    const badge = {
      ...values,
      accountId: user.accountId,
      personId: id,
      locationId: get(values.locationId, 'id', null),
      badgeDateExpired: dayjs(values.badgeDateExpired).format(
        DEFAULT_DATE_FORMAT
      ),
    };

    await addAccountPersonBadge(badge);

    const { account } = this.props;

    if (account.isError()) {
      return reduceServerErrors(account);
    }

    return this.setBadgeImages(
      id,
      badge.badgeNumber,
      badgeImageFront,
      badgeImageBack
    );
  };

  onDeletePerson = person => {
    this.setState({ deletingPerson: person });
  };

  onCancelDeletePerson = () => {
    this.setState({ deletingPerson: null });
  };

  onConfirmDeletePerson = async () => {
    const { deleteAccountPerson, user } = this.props;
    const { deletingPerson } = this.state;

    this.setState({ loading: true });
    this.onCancelDeletePerson();

    await deleteAccountPerson({
      accountId: user.accountId,
      personId: deletingPerson.id,
    });

    this.setState({ loading: false });

    const { account } = this.props;
    if (account.isError()) {
      return reduceServerErrors(account);
    }
    this.pagedPeople.refresh();
    toast(UiToastAdapter('Person deleted successfully!', 'success'));
    return undefined;
  };

  onRunBackgroundChecks = person => {
    const { user } = this.props;

    if (user.isBankAdmin) {
      this.setState({ runningBackgroundChecks: person });
    }
  };

  onApprove = async person => {
    const { user, updateAccountPersonStatus } = this.props;

    await updateAccountPersonStatus({
      accountId: user.accountId,
      personId: person.id,
      statusId: PERSON_STATUS.Approved,
    });

    this.pagedPeople.refresh();
  };

  onDeny = async person => {
    const { user, updateAccountPersonStatus } = this.props;

    await updateAccountPersonStatus({
      accountId: user.accountId,
      personId: person.id,
      statusId: PERSON_STATUS.Denied,
    });

    this.pagedPeople.refresh();
  };

  onCancelBackgroundCheck = form => {
    if (form) {
      form.reset();
    }
    this.setState({ runningBackgroundChecks: null });
  };

  onConfirmBackgroundCheck = async values => {
    const { runningBackgroundChecks } = this.state;
    const { account } = this.props;

    const packageProductCodes = values.packageCode.products;
    const customProductCodes = values.packageCode.isCustom
      ? values.productCodes
      : null;

    const response = await startBackgroundCheck({
      accountId: account.id,
      personId: runningBackgroundChecks.id,
      packageCode: values.packageCode.code,
      productCodes:
        packageProductCodes.length > 0
          ? packageProductCodes
          : customProductCodes,
    });

    if (!response.ok) {
      console.error(response.error);
      toast(
        UiToastAdapter(
          'There was an error starting the verifications, try again later',
          'danger'
        )
      );
    } else {
      this.pagedPeople.refetch();
      toast(UiToastAdapter('Background check started successfully', 'success'));
      this.onCancelBackgroundCheck();
    }
  };

  onResetPassword = async user => {
    const { emailAddress, firstName, lastName } = user;
    this.setState({ loading: true });

    const result = await resetPassword(emailAddress);

    if (result.ok) {
      toast(
        UiToastAdapter(
          `Password reset successfully for ${firstName} ${lastName}.`,
          'success'
        )
      );
    } else {
      toast(
        UiToastAdapter(
          `An error occurred while resetting the password for the requested person.`,
          'danger'
        )
      );
      console.error(result.error.body);
    }

    this.setState({ loading: false });
  };

  onSendInvite = async user => {
    const { emailAddress, firstName, lastName } = user;
    this.setState({ loading: true });

    const result = await sendInvite(emailAddress);

    if (result.ok) {
      toast(
        UiToastAdapter(
          `Invite successfully sent to ${firstName} ${lastName}.`,
          'success'
        )
      );
    } else {
      toast(
        UiToastAdapter(
          `An error occurred while sending an invite for the requested person.`,
          'danger'
        )
      );
      console.error(result.error.body);
    }

    this.setState({ loading: false });
  };

  async loadData() {
    const { user, fetchAccount } = this.props;

    this.setState({ loading: true });

    if (user.accountId) {
      await fetchAccount(user.accountId);

      const { account } = this.props;

      if (account.isError()) {
        toast(UiToastAdapter(account.errorMessage().detail, 'danger'));
        return;
      }

      await this.pagedPeople.fetch({ accountId: user.accountId });
    }
    this.setState({ loading: false });
  }

  render() {
    const {
      account: { businessName, insuranceGroupNames },
      user: {
        financialInstitutionName,
        financialInstitutionForBanking,
        financialInstitutionForLending,
        financialInstitutionForPayments,
        financialInstitutionForInsurance,
        isBankAdmin,
        isMerchantAdmin,
        isSuperAdmin,
        id: userId,
      },
    } = this.props;

    const {
      loading,
      isAddingOwner,
      isAddingEmployee,
      people,
      deletingPerson,
      runningBackgroundChecks,
      bgCheckPackages,
      isAdmin,
    } = this.state;

    if (!isMerchantAdmin && !isBankAdmin && !isSuperAdmin) {
      return <Navigate to={`/people/edit/${userId}`} />;
    }

    return (
      <>
        <Columns isMultiline>
          <Column isSize="1/2">
            <MuiTitle isSize="4" hasTextColor="info" tag="h2">
              People
            </MuiTitle>
          </Column>
          <Column hasTextAlign="right" isSize="1/2">
            <div className={isAdmin ? 'one-column-buttons' : null}>
              {isAdmin && !financialInstitutionForInsurance ? (
                <Link
                  to="/people/allowed-reports"
                  state={{ people, user: userId }}
                  className="button is-gradient-bright no-decoration"
                >
                  Allowed Reports
                </Link>
              ) : null}

              {financialInstitutionForInsurance ? (
                <AddPersonButton onAddPerson={this.onToggleAddEmployee} />
              ) : (
                this.dropdown()
              )}
            </div>
          </Column>

          <Column>
            {financialInstitutionForInsurance ? (
              <InsurancePeopleTable
                loading={loading}
                people={people}
                paging={this.pagedPeople}
                showActionsDropdown
                renderButton={this.dropdown()}
                onDeletePerson={this.onDeletePerson}
                onRunBackgroundChecks={
                  isBankAdmin ? this.onRunBackgroundChecks : null
                }
                onApprove={isBankAdmin ? this.onApprove : null}
                onDeny={isBankAdmin ? this.onDeny : null}
                onResetPassword={isBankAdmin ? this.onResetPassword : null}
                onSendInvite={isBankAdmin ? this.onSendInvite : null}
              />
            ) : (
              <PeopleTable
                loading={loading}
                people={people}
                paging={this.pagedPeople}
                accountId={this.props.account && this.props.account.id}
                showActionsDropdown
                renderButton={this.dropdown()}
                onDeletePerson={this.onDeletePerson}
                onRunBackgroundChecks={
                  isBankAdmin ? this.onRunBackgroundChecks : null
                }
                onApprove={isBankAdmin ? this.onApprove : null}
                onDeny={isBankAdmin ? this.onDeny : null}
                onResetPassword={isBankAdmin ? this.onResetPassword : null}
                onSendInvite={isBankAdmin ? this.onSendInvite : null}
              />
            )}
          </Column>
          {financialInstitutionForInsurance && (
            <Column isSize="narrow">
              <GuidelinesCard guidelines={this.guidelinesInsurance} />
            </Column>
          )}
          {!isBankAdmin &&
            financialInstitutionForBanking &&
            !financialInstitutionForLending &&
            !financialInstitutionForPayments && (
              <Column isSize="narrow">
                <GuidelinesCard guidelines={this.guidelinesBanking} />
              </Column>
            )}
          {!isBankAdmin &&
            financialInstitutionForPayments &&
            !financialInstitutionForInsurance && (
              <Column isSize="narrow">
                <GuidelinesCard guidelines={this.guidelinesPayments} />
              </Column>
            )}
          {!isBankAdmin && financialInstitutionForLending && (
            <Column isSize="narrow">
              <GuidelinesCard guidelines={this.guidelinesLending} />
            </Column>
          )}
        </Columns>
        <AddPersonModal
          type={PERSON_TYPE_OWNER}
          isActive={isAddingOwner}
          onCancel={this.onCancelAddPerson}
          onSubmit={this.onSubmitPerson}
          businessName={businessName || ''}
          financialInstitutionName={financialInstitutionName || ''}
        />
        <AddPersonModal
          type={
            financialInstitutionForInsurance
              ? PERSON_TYPE_INSURANCE
              : PERSON_TYPE_EMPLOYEE
          }
          isActive={isAddingEmployee}
          onCancel={this.onCancelAddPerson}
          onSubmit={this.onSubmitPerson}
          isBankAdmin={isBankAdmin}
          businessName={businessName || ''}
          financialInstitutionName={financialInstitutionName || ''}
          insuranceGroupNames={insuranceGroupNames}
        />
        <ConfirmDeletionModal
          isActive={!!deletingPerson}
          onClickCancel={this.onCancelDeletePerson}
          onClickConfirm={this.onConfirmDeletePerson}
          title={deletingPerson ? deletingPerson.name : ''}
        />
        {isBankAdmin && (
          <BackgroundCheckModal
            isActive={!!runningBackgroundChecks}
            onClickCancel={this.onCancelBackgroundCheck}
            onClickConfirm={this.onConfirmBackgroundCheck}
            title={runningBackgroundChecks ? runningBackgroundChecks.name : ''}
            bgCheckPackages={bgCheckPackages}
          />
        )}
      </>
    );
  }
}

PeopleListPage.propTypes = {
  token: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  account: propTypes.object.isRequired,
  fetchAccount: propTypes.func.isRequired,
  addAccountPerson: propTypes.func.isRequired,
  addAccountPersonBadge: propTypes.func.isRequired,
  setAccountPersonBadgeImages: propTypes.func.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  fetchAccountPeople: propTypes.func.isRequired,
  deleteAccountPerson: propTypes.func.isRequired,
  updateAccountPersonStatus: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
    token: getToken(state),
    account: getAccount(state),
  };
}

const connectedPeopleListPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchAccount,
  addAccountPerson,
  addAccountPersonBadge,
  setAccountPersonBadgeImages,
  fetchAccountPeople,
  deleteAccountPerson,
  updateAccountPersonStatus,
})(PeopleListPage);

// Functional component wrapper for the Add Person button
function AddPersonButton({ onAddPerson }) {
  return (
    <Button
      isColor="gradient-bright"
      onClick={() => {
        onAddPerson();
      }}
    >
      Add Person
    </Button>
  );
}

AddPersonButton.propTypes = {
  onAddPerson: propTypes.func.isRequired,
};

export { connectedPeopleListPage as PeopleListPage };
